import { TConferenceSaveLevel } from '../../../../common/rest/conference/conferenceSaveLevel';

export namespace Wording {

	export const NOT_OWNER_TEXT = 'Language can only be changed by the creator';

	// Every downgrade destroys something irreversibly (the raw sources go with it, so a later reprocess
	// can't rebuild it) — null only for 'video', which is the top of the ladder and can never be one.
	export const SAVE_LEVEL_CONFIRM: Record<TConferenceSaveLevel, { text: string; description: string } | null> = {
		video: null,
		audio: {
			text: 'Set save level to Audio?',
			description: 'The video of this recording will be deleted for everyone.',
		},
		transcription: {
			text: 'Set save level to Transcript?',
			description: 'The audio and video will be deleted for everyone — only the transcript is kept.',
		},
		nothing: {
			text: 'Set save level to Nothing?',
			description: 'This recording will be deleted for everyone.',
		},
	};

	// Shown in place of the reprocess controls for saveLevel=transcription/nothing, where there's never
	// anything left to rebuild from. Scoped to "Reprocessing" explicitly — the same panel still has
	// language/provider/save-level controls above it, which stay available.
	export const REPROCESS_UNAVAILABLE_TEXT = 'Reprocessing is unavailable at this save level';

	// Option labels for the saveLevel selector, shared by the in-call device popup and the settings panel.
	export const SAVE_LEVEL_LABELS: Record<TConferenceSaveLevel, string> = {
		video: 'Video',
		audio: 'Audio',
		transcription: 'Transcript',
		nothing: 'Nothing',
	};

	// Separate from SAVE_LEVEL_LABELS: the tray indicator says what is happening right now, not what
	// the option is called, so 'transcription'/'nothing' read differently there.
	export const SAVE_LEVEL_TRAY_LABELS: Record<TConferenceSaveLevel, string> = {
		video: 'Video',
		audio: 'Audio',
		transcription: 'Transcript',
		nothing: 'Not recording',
	};

	// One hint per saveLevel, shown under the selector for whichever level is currently chosen.
	export const SAVE_LEVEL_HINTS: Record<TConferenceSaveLevel, string> = {
		video:         'Video + audio + transcript',
		audio:         'Audio + transcript, no video',
		transcription: 'Transcript only — audio is deleted once transcribed',
		nothing:       'Nothing is saved',
	};

}
